module.exports = "/_next/static/resources/photo-3-538d74e8033172fdfaa7124e5ac9313f.webp";